const EUR_RATE = 170

/** Units of a currency per EUR, real mid-market rates on 2026-10-16, frozen for the demo. */
const unitsPerEur: Record<string, number> = {
  AED: 4.119,
  AFN: 72.78,
  ALL: 91.26,
  AMD: 405.6,
  ANG: 2.007,
  AOA: 1070,
  ARS: 1698,
  AUD: 1.621,
  AWG: 2.007,
  AZN: 1.906,
  BAM: 1.956,
  BBD: 2.243,
  BDT: 138.1,
  BGN: 1.956,
  BHD: 0.4217,
  BIF: 3366,
  BMD: 1.122,
  BND: 1.438,
  BOB: 13.13,
  BRL: 5.667,
  BSD: 1.122,
  BTN: 106.5,
  BWP: 15.83,
  BYN: 3.378,
  BZD: 2.243,
  CAD: 1.592,
  CDF: 2599,
  CHF: 0.9292,
  CLP: 1105,
  CNH: 7.501,
  CNY: 7.509,
  COP: 3570,
  CRC: 510.5,
  CUP: 26.92,
  CVE: 110.3,
  CZK: 24.35,
  DJF: 199.3,
  DKK: 7.475,
  DOP: 68.66,
  DZD: 150.9,
  EGP: 59.93,
  ERN: 16.82,
  ETB: 186.7,
  FJD: 2.53,
  FKP: 0.8454,
  GBP: 0.8454,
  GEL: 2.912,
  GGP: 0.8454,
  GHS: 13.07,
  GIP: 0.8454,
  GMD: 83.68,
  GNF: 9873,
  GTQ: 8.565,
  GYD: 234.7,
  HKD: 8.798,
  HNL: 30.15,
  HRK: 7.535,
  HTG: 146.9,
  HUF: 363.9,
  IDR: 20120,
  IMP: 0.8454,
  INR: 106.6,
  IQD: 1703,
  IRR: 2007000,
  ISK: 136.4,
  JEP: 0.8454,
  JMD: 178.5,
  JOD: 0.7951,
  JPY: 177.2,
  KES: 145.4,
  KGS: 98.09,
  KHR: 4549,
  KMF: 492,
  KRW: 1507,
  KWD: 0.3476,
  KYD: 0.9346,
  KZT: 507.8,
  LAK: 25020,
  LBP: 100400,
  LKR: 371.3,
  LRD: 191.6,
  LSL: 18.52,
  LYD: 7.205,
  MAD: 10.97,
  MDL: 20.07,
  MGA: 5073,
  MKD: 61.5,
  MMK: 2353,
  MNT: 4057,
  MOP: 9.062,
  MRU: 45.17,
  MUR: 53.04,
  MVR: 17.34,
  MWK: 1955,
  MXN: 20.69,
  MYR: 4.578,
  MZN: 71.57,
  NAD: 18.52,
  NGN: 1491,
  NIO: 41.28,
  NOK: 10.63,
  NPR: 170.5,
  NZD: 1.996,
  OMR: 0.4312,
  PAB: 1.122,
  PEN: 3.85,
  PGK: 5.049,
  PHP: 70.67,
  PKR: 310.6,
  PLN: 4.369,
  PYG: 6394,
  QAR: 4.082,
  RON: 5.335,
  RSD: 117.4,
  RUB: 94.02,
  RWF: 1658,
  SAR: 4.206,
  SBD: 8.994,
  SCR: 15.9,
  SDG: 501.7,
  SEK: 11.17,
  SGD: 1.438,
  SHP: 0.8454,
  SLL: 27310,
  SOS: 641.4,
  SRD: 42.5,
  SSP: 6848,
  STN: 24.5,
  SYP: 136.5,
  SZL: 18.52,
  THB: 37.58,
  TJS: 10.35,
  TMT: 3.925,
  TND: 3.362,
  TOP: 2.681,
  TRY: 55.5,
  TTD: 7.897,
  TWD: 36.3,
  TZS: 2936,
  UAH: 50.38,
  UGX: 4469,
  USD: 1.122,
  UYU: 45.06,
  UZS: 13420,
  VND: 29000,
  VUV: 134.2,
  WST: 3.084,
  XAF: 656,
  XCD: 3.028,
  XOF: 656,
  XPF: 119.3,
  YER: 264.7,
  ZAR: 18.52,
  ZMW: 22.54
}

/** Demo values for a brand with `monetisation.hasPointsProgram`. Constant: every user sees the same ones. */
export const pointsProgram = {
  programName: 'Frequent Flyer',
  memberNumber: '130421226',
  balance: 95044,
  /** Points for one unit of a currency. A currency absent here has no points price. */
  rates: {
    ...Object.fromEntries(
      Object.entries(unitsPerEur).map(([code, units]) => [
        code,
        EUR_RATE / units
      ])
    ),
    EUR: EUR_RATE,
    // El Al's rate from the refinement call, off the market one on purpose.
    ILS: 40
  } as Record<string, number | undefined>,
  coupon: {
    discount: 0.1
  },
  /** Share of the redemption rate a paid booking earns back. */
  earnRatio: 0.1
}

export const getPointsRate = (currencyCode: string) =>
  pointsProgram.rates[currencyCode]

/** Points for an amount, or `undefined` when the currency has no rate. */
export const toPoints = (amount: number, currencyCode: string) => {
  const rate = getPointsRate(currencyCode)

  return rate === undefined ? undefined : amount * rate
}

/** Currency value of points, or `undefined` when the currency has no rate. */
export const toCurrency = (points: number, currencyCode: string) => {
  const rate = getPointsRate(currencyCode)

  return rate === undefined ? undefined : points / rate
}

/** Whole points a booking of this amount earns, or `undefined` when the currency has no rate. */
export const toEarnedPoints = (amount: number, currencyCode: string) => {
  const points = toPoints(amount, currencyCode)

  return points === undefined
    ? undefined
    : Math.round(points * pointsProgram.earnRatio)
}
